export default __webpack_public_path__ + "static/media/header-background.6aec97de.avif";